import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import * as URL from './urls';
import ISistemAlertRepositoryDataRepository from './iSistemAlertDataRepository';
import { SistemAlertsListDTO } from '../dto/SistemAlertsDTO';
import { SistemAlertsMapper } from '../mappers/sistemAlerts.mapper';

class SistemAlertRepository
  extends BaseRepository
  implements ISistemAlertRepositoryDataRepository
{
  private readonly _api: IApi;
  private readonly _apiGetSystemAlerts: string;

  constructor({ api, apiGetSystemAlerts }) {
    super();
    this._api = api;
    this._apiGetSystemAlerts = apiGetSystemAlerts;
  }

  getSistemAlertData({ queryParams }: { queryParams: object }) {
    return this._api
      .get(`${this._apiGetSystemAlerts}${this._createQueryParams(queryParams)}`)
      .then((res) => {
        const response = new SistemAlertsListDTO(res);
        return SistemAlertsMapper.toDomainList(response.data);
      });
  }
}

export default new SistemAlertRepository({
  api: api,
  apiGetSystemAlerts: URL.API_GET_SYSTEM_ALERTS
});

export { SistemAlertRepository };
